export const distributionDemoProjects = [
  {
    id: 201,
    _id: 'mock-da-201',
    project_name: 'Gatorade Distribution Optimization',
    brand_name: 'Gatorade',
    createdAt: '2026-05-02T11:00:00.000Z',
    creator: { name: 'Local Admin' },
  },
  {
    id: 202,
    _id: 'mock-da-202',
    project_name: 'Quaker Regional Load Plan',
    brand_name: 'Quaker',
    createdAt: '2026-05-04T09:20:00.000Z',
    creator: { name: 'Local Admin' },
  },
  {
    id: 203,
    _id: 'mock-da-203',
    project_name: 'Frito Lay DC Simulation',
    brand_name: 'Frito Lay',
    createdAt: '2026-05-08T13:10:00.000Z',
    creator: { name: 'Demo User' },
  },
];

export const testLogDemoProjects = [
  {
    id: 101,
    projectName: 'Gatorade 20oz Pallet Validation',
    createdAt: '2026-05-01T10:30:00.000Z',
    creator: { name: 'Local Admin' },
    overallDecision: 'pass',
  },
  {
    id: 102,
    projectName: 'Quaker Multipack Stack Trial',
    createdAt: '2026-05-03T14:15:00.000Z',
    creator: { name: 'Local Admin' },
    overallDecision: 'pending',
  },
  {
    id: 103,
    projectName: "Lay's Club Pack Transit Test",
    createdAt: '2026-05-06T08:45:00.000Z',
    creator: { name: 'Demo User' },
    overallDecision: 'fail',
  },
];

export const isMockDistributionProjectId = (id?: string | number) => {
  if (!id) return false;
  return distributionDemoProjects.some((project) => String(project.id) === String(id));
};

export const getMockDistributionRequestItem = (id?: string | number) => {
  const project = distributionDemoProjects.find((item) => String(item.id) === String(id)) || distributionDemoProjects[0];

  return {
    id: project.id,
    isMock: true,
    project_name: project.project_name,
    brand_name: project.brand_name,
    location_name: 'Plano R&D',
    customer: 'PepsiCo',
    application_name: 'Cold Fill',
    primary_package_type: 'pet_bottles',
    category: 'Hydration',
    bottle_design: 'Contour',
    net_contents: '591',
    net_contents_unit: 'ml',
    filled_top_load: '90',
    filled_top_load_unit: 'lbf',
    primary_package_diameter: '2.72',
    primary_package_diameter_unit: 'inch',
    primary_package_height: '8.25',
    primary_package_height_unit: 'inch',
    has_tertiary_package: 'yes',
    items_per_case: '24 (4x6)',
    pack_per_case: '4 (2x2)',
    secondary_package_type: 'Tray',
    secondary_topload_filled: '85',
    secondary_topload_filled_unit: 'lbf',
    secondary_weight: '22.01',
    secondary_weight_unit: 'lbs',
    secondary_length: '13.40',
    secondary_length_unit: 'inch',
    secondary_width: '11.90',
    secondary_width_unit: 'inch',
    secondary_height: '5.10',
    secondary_height_unit: 'inch',
    tertiary_material: 'Corrugated Case',
    tertiary_bct: '160',
    tertiary_bct_unit: 'lbf',
    tertiary_length: '27.10',
    tertiary_length_unit: 'inch',
    tertiary_width: '23.80',
    tertiary_width_unit: 'inch',
    tertiary_height: '10.90',
    tertiary_height_unit: 'inch',
    tertiary_weight: '48.50',
    tertiary_weight_unit: 'lbs',
    pallet_base_type: '48x40x5 Wood',
    pallet_pattern: 'Split Row',
    number_of_layers: '7',
    cases_per_layer: '21',
    k_value: '5',
    chosenCases: [
      { project_name: 'P004-680', pallet_pattern: 'Split Row', cases_per_layer: '21' },
      { project_name: 'P003-221', pallet_pattern: 'Pin Wheel', cases_per_layer: '20' },
    ],
  };
};

const mockKnnDetailColumns = [
  'Volume(ml)',
  'FilledWeight(g)',
  'Items/Case',
  'Pallet Dimension (inches)',
  'Pallet Material',
  'UnitloadLength(in)',
  'UnitloadWidth(in)',
  'UnitloadHeight(in)',
  'Cases Per Layer',
  'Items/pallet',
  'PreShip_Lean',
  "('PreShipForceToload', 'TOP ')",
  "('PreShipForceToload', 'Middle')",
  "('PreShipForceToload', 'Bottom')",
  'PostShip_Lean',
  "('PostShipForceToload', 'TOP ')",
  "('PostShipForceToload', 'Middle ')",
  "('PostShipForceToload', 'Bottom')",
  'PostShip_Walk',
  'PostStack_Lean',
  'Post Stack Compression_Rebound',
];

const mockTestCaseDetails = [500, 544.3, 18, '48x40x5', 'Wood', 51, 40.5, 59, 18, 1296, 1.5, 21, 20, 23, 2, 20, 19, 21, 0.75, 2.5, 0.75];
const mockSpecDetails = [500, 512.8, 12, '48x40x5', 'Wood', 51, 40.5, 59, 18, 1296, '', '', '', '', '', '', '', '', '', '', ''];
const mockDcs1040ControlDetails = [500, 544.3, 12, '48x40x5', 'Wood', 51, 40.5, 59, 10, 1920, 1.5, 21, 20, 23, 2, 20, 19, 21, 0.75, 2.5, 0.75];
const mockDcs1040VariableDetails = [500, 544.3, 12, '48x40x5', 'Wood', 51.5, 41, 60, 10, 1920, 1.7, 20, 19, 22, 2.1, 19, 18, 20, 0.9, 2.7, 0.8];
const mockDcs0875Details = [500, 507.6, 12, '48x40x5', 'Wood', 50, 40, 58, 10, 1920, 1.9, 18, 17, 20, 2.4, 17, 16, 19, 1.1, 2.8, 1];

export const mockKnnData = {
  columns: [
    'SPEC NUMBER',
    'Brand',
    'Package Material',
    'Bottle Design',
    'Category',
    'Diameter(in)',
    'Height(in)',
    'primary_distance',
    'Secondary/Tertiary PackageType',
    'CaseLength(in)',
    'CaseWidth(in)',
    'CaseHeight(in)',
    'secondary_distance',
    'Tertiary PackageType',
    'TertiaryLength(in)',
    'TertiaryWidth(in)',
    'TertiaryHeight(in)',
    'tertiary_distance',
    'Pallet Pattern Stackup',
    'pallet_similarity',
    'Stacking Pattern',
    'Status',
    'Shipping Mode',
    'Distance(miles)',
    'Variable Name',
    'Data Source',
    ...mockKnnDetailColumns,
  ],
  data: [
    ['TEST CASE', 'Gatorade', 'PET', 'Contour', 'Hydration', 2.72, 8.25, 100, 'Tray', 13.4, 11.9, 5.1, 100, 'Corrugated Case', 27.1, 23.8, 10.9, 100, 'Split Row', 100, '2-HIGH COLUMN', '', 'Truck', 1000, 'Test Case', 'test case', ...mockTestCaseDetails],
    ['P004-680', 'Gatorade', 'PET', 'Contour', 'Hydration', 2.71, 8.22, 98.34, 'Tray', 13.35, 11.8, 5.05, 97.59, 'Corrugated Case', 27.0, 23.7, 10.8, 96.94, 'Split Row', 94.4, '2-HIGH COLUMN', '', 'Truck', 1000, 'Specification match', 'specification', ...mockSpecDetails],
    ['P003-221', 'Gatorade', 'PET', 'Contour', 'Hydration', 2.75, 8.3, 96.73, 'Tray', 13.55, 12.0, 5.2, 95.12, 'Corrugated Case', 27.4, 24.0, 11.0, 94.88, 'Pin Wheel', 91.8, '2-HIGH PYRAMID', '', 'Truck', 1000, 'Specification match', 'specification', ...mockSpecDetails],
    ['P001-572', 'Propel', 'PET', 'Ripples', 'Hydration', 2.69, 8.15, 94.11, 'Shrink W Tray', 13.1, 11.7, 5.0, 92.2, 'Paperboard', 26.6, 23.2, 10.5, 90.15, 'Row', 86.2, '3-HIGH COLUMN', '', 'Rail', 800, 'Specification match', 'specification', ...mockSpecDetails],
    ['DCS-1040', 'Gatorade', 'PET', 'Contour', 'Hydration', 2.73, 8.24, 97.2, 'Tray', 13.4, 11.9, 5.1, 96.8, 'Corrugated Case', 27.1, 23.9, 10.9, 95.5, 'Split Row', 93.5, '2-HIGH COLUMN', 'Pass', 'Truck', 1000, 'Control 1', 'physical', ...mockDcs1040ControlDetails],
    ['DCS-1040', 'Gatorade', 'PET', 'Contour', 'Hydration', 2.74, 8.28, 95.8, 'Tray', 13.6, 12.0, 5.2, 94.7, 'Corrugated Case', 27.4, 24.1, 11.1, 93.2, 'Pin Wheel', 89.7, '2-HIGH COLUMN', 'Pass', 'Truck', 1000, 'Variable 1', 'physical', ...mockDcs1040VariableDetails],
    ['DCS-0875', 'Gatorade', 'PET', 'Contour', 'Hydration', 2.8, 8.4, 91.4, 'Tray', 13.8, 12.1, 5.4, 89.7, 'Corrugated Case', 27.7, 24.2, 11.3, 88.3, 'Split Row', 84.6, 'Truck-Air Ride', 'Fail', 'Truck', 1000, 'Variable 1', 'physical', ...mockDcs0875Details],
  ],
  data_2: [
    ['TEST CASE', 'Gatorade', 'PET', 'Contour', 'Hydration', 2.72, 8.25, 100, 'Tray', 13.4, 11.9, 5.1, 100, 'Corrugated Case', 27.1, 23.8, 10.9, 100, 'Split Row', 100, '2-HIGH COLUMN', '', 'Truck', 1000, 'Test Case', 'test case', ...mockTestCaseDetails],
    ['P004-680', 'Gatorade', 'PET', 'Contour', 'Hydration', 2.71, 8.22, 98.34, 'Tray', 13.35, 11.8, 5.05, 97.59, 'Corrugated Case', 27.0, 23.7, 10.8, 96.94, 'Split Row', 94.4, '2-HIGH COLUMN', '', 'Truck', 1000, 'Specification match', 'specification', ...mockSpecDetails],
    ['P003-221', 'Gatorade', 'PET', 'Contour', 'Hydration', 2.75, 8.3, 96.73, 'Tray', 13.55, 12.0, 5.2, 95.12, 'Corrugated Case', 27.4, 24.0, 11.0, 94.88, 'Pin Wheel', 91.8, '2-HIGH PYRAMID', '', 'Truck', 1000, 'Specification match', 'specification', ...mockSpecDetails],
    ['P001-572', 'Propel', 'PET', 'Ripples', 'Hydration', 2.69, 8.15, 94.11, 'Shrink W Tray', 13.1, 11.7, 5.0, 92.2, 'Paperboard', 26.6, 23.2, 10.5, 90.15, 'Row', 86.2, '3-HIGH COLUMN', '', 'Rail', 800, 'Specification match', 'specification', ...mockSpecDetails],
    ['DCS-1040', 'Gatorade', 'PET', 'Contour', 'Hydration', 2.73, 8.24, 97.2, 'Tray', 13.4, 11.9, 5.1, 96.8, 'Corrugated Case', 27.1, 23.9, 10.9, 95.5, 'Split Row', 93.5, '2-HIGH COLUMN', 'Pass', 'Truck', 1000, 'Control 1', 'physical', ...mockDcs1040ControlDetails],
    ['DCS-1040', 'Gatorade', 'PET', 'Contour', 'Hydration', 2.74, 8.28, 95.8, 'Tray', 13.6, 12.0, 5.2, 94.7, 'Corrugated Case', 27.4, 24.1, 11.1, 93.2, 'Pin Wheel', 89.7, '2-HIGH COLUMN', 'Pass', 'Truck', 1000, 'Variable 1', 'physical', ...mockDcs1040VariableDetails],
    ['DCS-0875', 'Gatorade', 'PET', 'Contour', 'Hydration', 2.8, 8.4, 91.4, 'Tray', 13.8, 12.1, 5.4, 89.7, 'Corrugated Case', 27.7, 24.2, 11.3, 88.3, 'Split Row', 84.6, 'Truck-Air Ride', 'Fail', 'Truck', 1000, 'Variable 1', 'physical', ...mockDcs0875Details],
  ],
};
